import { ReportAPI } from 'api'
import React from 'react'
import { match } from 'ts-pattern'
import { PanelComponent } from '../../../components/Panel/Panel'
import useCurrentUserStore from '../../../stores/currentUser'
import { matchRegExp } from '../../../utils'

export default function ReportNotes({ report }: { report: ReportAPI.Data }) {
  const roles = useCurrentUserStore((s) => s.currentUser?.data?.roles)

  return (
    <>
      {match(`${roles}_${report?.state}`)
        .when(
          matchRegExp(/(user|superadmin)_need_to_revise/),
          () =>
            report?.notesWhistleblower && (
              <PanelComponent
                header="Catatan dari Admin!"
                variant="error"
                mb="3"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: report.notesWhistleblower,
                  }}
                />
              </PanelComponent>
            )
        )
        .when(
          matchRegExp(/(admin_verificator|superadmin)_reported/),
          () =>
            report?.notesVerificator && (
              <PanelComponent header="Catatan dari UP2!" variant="error" mb="3">
                <div
                  dangerouslySetInnerHTML={{ __html: report.notesVerificator }}
                />
              </PanelComponent>
            )
        )
        .when(
          matchRegExp(/(admin_investigator|superadmin)_reviewed/),
          () =>
            report?.notesInvestigator && (
              <PanelComponent header="Catatan dari UP2!" variant="error" mb="3">
                <div
                  dangerouslySetInnerHTML={{ __html: report.notesInvestigator }}
                />
              </PanelComponent>
            )
        )
        .otherwise(() => null)}
    </>
  )
}
